export enum DocumentLinkDataEnum {

    Other = 'other',

    Html = 'html',

    Global = 'global',

}
